module.exports = __webpack_public_path__ + "img/QR-invitation.65c98bd1.png";